export default __webpack_public_path__ + "static/media/icon-double-chevron-right.649af150.svg";